﻿'use strict';

if (!window.i18n) {
	window.i18n = {};
}

if (!window.i18n.languages) {
	window.i18n.languages = {};
}

window.i18n.languages['ja_JP'] = {
	optional:"オプション",
	needBet: "賭けが必要:",
	needDeposit:"保証金が必要:",

	agentCode : "招待コード",

	tips_fail:"申し立てに失敗しました",
	a_stauts: "アクティブステータス",
	activityDetails_hdjxz: "進行中の活動",
	activityDetails_hdwks: "活動は始まっていない",
	activityDetails_hdyjs: "イベントは終わりました",

	a_time: `活動時間`,
	a_status: `アクティブステータス`,
	a_rule: `報酬ルール`,
	a_content: `アクティビティ詳細`,

	gameCoin:"ゲーム通貨",
	register_chooseCurrency: "預金通貨を選択",
	register_tips0:"*登録後の通貨変更はできません",
	register_curInstruction:"通貨の説明：",
	register_tips1:"1.ユーザーの現在の通貨をサポートしていないゲームに参加する場合、為替レートで換算された金額がゲームに持ち込まれます。",
	register_tips2:"2.ユーザーの入出金方法は、ユーザーの現在の通貨サポートを表示することです。",

	sendSuccess:"正常に送信されました!",
	login_areaCode: '国コード',
	login_selectAreaCode: '国または地域を選択してください',
	new_maxVipLV: 'おめでとう！ ！あなたは現在最高レベルにいます',
	currency_symbol : "J￥",
	language : "日本言語",

	new_r_rate: 'ゲームに持ち込まれた金額は、為替レート換算後の金額です。',
	new_r_rate1: '為替レート：',
	new_r_money: 'ゲーム内の金額：',
	new_r_tips6: '*サードパーティのゲームに転送する場合にのみ整数を取り込むことができることに注意してください',
	new_r_tips7: '為替レートのリマインダー',
	new_r_tips8: '知っている',
	new_r_tips9: 'あなたは現在入っています',
	new_r_game: "ゲーム",

	"ActivityNew": {
	"btn_lingqu": "今すぐ入手",
	"btn_back": "戻る",
	"toggle_zonghe": "包括的な活動",
	},

	"SignIn": {
		"btnLingqu": "受け取る",
	},

	"label_text": {
		"title": "報酬を獲得する",
		"loading_msg": "アップデートリソースパックをダウンロードする",
		"not_logged": "ログインしていない",
		"password": "パスワード：",
		"verify": "検証コード：",
		"verify_msg": "確認コードを入力してください",
		"inPlease_enter_the": "入ってください",
		"phone": "携帯電話",
		"No": "数",
		"determine": "決定する",
		"receive": "受け取る",
		"Image_preview": "アバタープレビュー",
		"Install": "今すぐインストール",
		"obtain": "おめでとうございます",
		"check_update": "アップデートの確認...",
		"real_name": "実際の名前",
		"tips": "悪いゲームに抵抗し、海賊版ゲームを拒否します。自己防衛に注意を払い、だまされないように注意してください。適度なゲームは脳に利益をもたらし、ゲームの飲み物を楽しみます。時間を合理的に調整し、健康的な生活をお楽しみください。",
		"tishi": "促す",
		"no_data": "データなし",
		"queding": "決定する",
		"quxiao": "キャンセル",
		"download_new_version": "この機能を使用するには、アプリの最新バージョンをダウンロードしてください",
		"online_kefu": "オンラインサービス",
		"save_account": "アカウント情報を保存する",
	},

	"data_req_text": {
		"login_failure": "ログインの有効期限が切れています。もう一度ログインしてください",
	},

	"login_text": {
		"account_pro": "アカウント番号を空にすることはできません。入力してください。",
		"psw_pro": "パスワードを空にすることはできません。入力してください。",
		"vfy_pro": "確認コードを空にすることはできません。入力してください。",
		"quick_login_fail": "クイックログインに失敗しました！",
		"account": "口座番号：",
		"account_msg": "アカウント/電話番号を入力してください",
		"paw_msg": "パスワードを入力してください",
		"Remember_acc": "私を覚えてますか",
		"forget_paw": "パスワードを忘れましたか？",
		"no_acc": "アカウントなし、",
		"go_reg": "登録に移動>",
		"confirm_login": "ログインの確認",
		"quick_login": "クイックログイン",
		"confirm_register": "登録を確認する",
		"register_cg": "登録完了",
		"account_data": "口座情報",
        "sfyz": "認証",
        "sfyz_tip": "尊敬するお客様、こんにちは。あなたの口座の安全を守るために、今回の登録には以下の検証が必要です。悪意のあるプログラムが自動的に登録されないようにします。",
        "bind_bank": "バインディングされた銀行カードを入力してください",
        "bind_alipay": "バインディングされたペイアウトを入力してください",
        "bank_card": "銀行カード:",
        "alipay": "アリペイ:",
        "code": "認証コード:",
        "enter_bank_card": "銀行カード番号を入力してください",
        "enter_alipay": "アリペイアカウントを入力してください",
        "enter_code": "認証コードを入力してください",
	},

	"register_text": {
		"perfect_suc": "情報を正常に入力してください。",
		"perfect_err": "完全なデータが失敗しました！",
		"inp_data": "最初に情報を入力してください！",
		"inp_email": "メールアドレスを入力してください",
		"inp_phone": "電話番号を入力してください",
		"inp_wx": "WeChatIDを入力してください",
		"inp_qq": "QQ番号を入力してください",
		"email": "メールボックス：",
		"wx_No": "WeChat：",
		"qq_No": "QQ番号：",
		"phone": "電話番号：",
		"user_name": "ユーザー名：",
		"user_msg": "6～12文字または数字のアカウント",
		"user_pro": "6～12文字または数字または記号のパスワード",
		"paw_pro": "パスワードは6〜12桁の数字と文字の組み合わせです",
		"confirm_paw_pro": "確認パスワードを空にすることはできません。入力してください。",
		"paw_consistent": "パスワードと確認済みのパスワードに矛盾があります。もう一度入力してください。",
		"paw_msg": "6〜12文字と数字のパスワードを入力してください",
		"confirm_msg": "もう一度パスワードを確認してください",
		"phone_msg": "電話確認コードを入力してください",
		"con_paw": "パスワードを認証する：",
		"exi_acc": "すでにアカウントをお持ちですか、",
		"go_log": "ログインに移動>",
		"send_verify": "送信",
		"retry_verify": "再送",
		"phone_confirm": "正しい電話番号を入力してください！",
		"register_suc": "登録完了！",
		"user_not_mag": "ユーザー名を空にすることはできません。入力してください。",
		"No_null": "番号を空にすることはできません。記入してください。",
		"correct_phone": "正しい電話番号を入力してください！",
		"phone_vfy": "電話確認コードを空にすることはできません。入力してください。",
		"loss_account": "アカウントが失われるのを防ぐために、アカウントを保存してください",
		"account_change": "アカウントは一度だけ変更できます。[変更]をクリックしてください",
		"please_tick": "チェックボタンをクリックして、アカウントのパスワードを確認してください。",
		"save_suc": "正常に保存されました！",
		"save_err": "保存に失敗しました！手動でスクリーンショットを撮ってください!",

		"currency": "通貨：",
		"language": "言語：",

	},

	"datum_text": {
		"datum_title": "情報を送信する",
		"bank_card": "銀行カード番号：",
		"inPlease_enter_the": "入ってください...",
		"input_datum": "最初にデータを入力してください",
		"update_img": "画像をアップロード",
		"select_update_img": "アップロードした写真を選択してください",
		"limit_type": "アップロードできるのはJPG、JPEG、PNGのみです",
		"msg_update_data": "最初にデータをアップロードしてください",
		"mag_update_pic": "最初に正しい形式で写真をアップロードしてください",
		"apply_succ": "申し込みは正常に送信されました。確認をお待ちください",
	},

	"task_text": {
		"activity": "アクティビティ",
		"task": "仕事",
		"announcement": "発表",
		"sign": "サインイン",
		"task_name": "ミッション名：",
		"task_detail": "タスクの詳細",
		"task_time": "タスクの有効時間：",
		"task_content": "タスクの内容：",
	},

	"customer_text": {
		"jump_whatsapp": "whatsapp アカウントが正常にコピーされました，whatsapp へのリダイレクトをリクエストしてください",
		"jump_telegram": "telegram アカウントが正常にコピーされました，telegram へのリダイレクトをリクエストしてください",
		"jump_Messenger": "Messenger アカウントが正常にコピーされました ，Messenger へのリダイレクトをリクエストしてください",
		"jump_Viber": "Viber アカウントが正常にコピーされました，Viber へのリダイレクトをリクエストしてください",
		"no_whatsapp": "whatsapp がデバイスにインストールされていません",
		"no_telegram": "telegram がデバイスにインストールされていません",
		"no_Messenger": "Messenger がデバイスにインストールされていません",
		"no_Viber": "Viber がデバイスにインストールされていません",

		"contact_customer": "カスタマーサービスにお問い合わせください",
		"not_ind_qq": "QQがデバイスにインストールされていません",
		"jump_wx": "WeChatアカウントが正常にコピーされました。WeChatへのリダイレクトをリクエストしてください",
		"not_ind_wx": "WeChatがデバイスにインストールされていません",
		"jump_mt": "MTカスタマーサービスアカウントが正常にコピーされました。MTカスタマーサービスのリダイレクトをリクエストしてください",
		"Online": "オンラインサービス",
		"QQ": "QQカスタマーサービス",
		"WECHAT": "WeChatカスタマーサービス",
		"MT": "MTカスタマーサービス",
		"CJ": "一般的な問題",
		"contact_online": "カスタマーサービスにお問い合わせください",
		"copy_wx": "WeChatIDをコピーする",
		"copy_mt": "MT番号をコピーする",
	},

	"msg_text": {
		"save_date": "メッセージは最大1か月間保存されます",
		"message": "ニュース",
		"email": "郵便物",
		"receive": "受け取りました",
		"overdue": "期限切れ",
		"not_delete": "削除できません。最初に報酬を集めてください",
		"not_be_deleted": "未請求のメールは削除されません",
	},

	"basic_text": {
		"basic_title": "基本情報",
		"account": "口座番号：",
		"nickname": "ニックネーム：",
		"name": "名前：",
		"com_title": "通信情報",
		"qq": "Q Q：",
		"wx": "WeChat：",
		"phone": "携帯電話：",
		"email": "メールボックス：",
	},

	"baes_text": {
		"unit": "元",
		"view": "見る",
		"yes": "はい",
		"no": "番号",
		"update": "更新",
		"cancel": "キャンセル",
		"mail_system": "システムメール",
		"connected": "接続します、しばらくお待ちください...",
		"coin": "ゴールド",
	},

	"pre_details_text": {
		"detail": "充電の詳細",
		"lxkf": "カスタマーサービスにお問い合わせください",
		"rkz": "預け入れ...",
		"copy": "コピー",
		"order": "注文番号",
		"date": "充電時間",
		"czType": "充電方法",
		"transfer": "転送",
		"succ": "成功",
		"error": "失敗",
		"audit": "レビュー中",
		"czSucc": "再充電に失敗しました",
		"copy_succ": "正常にコピー",
		"order_num": "注文番号",
	},

	"USDT_text": {
		"second_step": "ステップ2：USDTチェーン情報",
		"url_name": "チェーン名",
		"alipay": "Ali-Payで支払う",
		"url": "チェーンアドレス...",
	},

	"set_text": {
		"set_music": "音楽の設定",
		"switch_music": "音楽の切り替え",
		"change_d_paw": "ログインパスワードを変更する",
		"change_t_paw": "引き出しパスワードを変更する",
		"version": "現行版",
		"huidu": "グレースケール",
		"swi_test": "ベータ版に切り替えますか？",
		"swi_hui": "グレースケールバージョンに切り替えるかどうか？",
		"old_paw_null": "古いパスワードを空にすることはできません。入力してください。",
		"new_paw_null": "新しいパスワードを空にすることはできません。入力してください。",
		"old_paw_limit_length": "古いパスワードは6〜12桁です",
		"new_paw_limit_length": "新しいパスワードは6〜12桁の数字と文字の組み合わせです",
		"new_paw_limit": "古いパスワードは6桁である必要があります。もう一度入力してください",
		"con_paw_null": "確認パスワードを空にすることはできません。入力してください。",
		"con_paw_consistent": "パスワードと確認済みのパスワードに矛盾があります。もう一度入力してください。",
		"new_old_paw_consistent": "新しいパスワードを古いパスワードと同じにすることはできません。もう一度入力してください。",
		"change_succ": "おめでとうございます。パスワードは正常に変更されました。もう一度ログインしてください。",
		"tx_paw_null": "引き出しパスワードを空にすることはできません。記入してください",
		"con_tx_paw": "引き出しパスワードを空にできないことを確認してください、記入してください",
		"tx_paw_consistent": "引き出しパスワードが確認パスワードと一致していません。確認してください",
		"tx_paw_limit": "引き出しパスワードは6桁である必要があります。もう一度入力してください",
		"paw_change_succ": "おめでとうございます。パスワードが正常に変更されました",
		"latest_version": "これはアプリの最新バージョンです",
		"switch_server": "スイッチサーバー",
		"switch_language": "言語を切り替える",
		"change_language_tips": "一部のページの言語は、アプリケーションを再起動すると有効になります",
		"restart": "リブート",
	},

	"share_text": {
		"copy_wa": "コピーコピー",
		"save_img": "画像を保存する",
		"share_py": "友達の輪を共有する",
		"submit_audit": "レビュー送信",
		"copy_succ": "正常にコピー",
		"save_img_succ": "写真を正常に保存する",
		"save_err": "画像の保存に失敗しました。写真を保存するためにこのアプリケーションの許可を開くには、電話設定ページに移動してください",
		"share_go": "共有先：",
		"share_err_qq": "共有に失敗しました。QQをインストールまたは確認して、再試行してください",
		"share_err_wx": "共有に失敗しました。WeChatをインストールまたは確認して、再試行してください",
		"share_err_wl": "バインドに失敗しました。ネットワークを確認して、再試行してください",
		"shareIntroduce_title": "チュートリアルを共有する",
		"inviteFriends": "友達を招待",
	},

	"hot_text": {
		"dzyx": "世界的に人気のあるビデオゲームを集めて、熱意は衰えず、勝率は高くなっています。1000万の贈り物があなたが勝つのを待っています！",
		"qbyx": "世界で最も人気のあるボードゲームを集めれば、人気は衰えず、勝率は高くなり、数千万のギフトを獲得できます！",
		"byyx": "世界で最も人気のある釣りゲームの集まりで、熱意は衰えず、勝率は高くなっています。1,000万のギフトがあなたの勝利を待っています！",
		"rmqp": "人気のチェス",
		"rmdz": "人気のエレクトロニクス",
		"rmby": "人気の釣り",
		"ljyx": "今すぐプレイ",
	},

	"agent_text": {
		"my_id": "私のID：",
		"under": "昨日の直接手数料：",
		"offline": "昨日のオフライン委員会：",
		"under_player": "直接プレイヤー：",
		"day_new": "昨日追加：",
		"offline_player": "オフラインプレーヤー：",
		"bind_wx": "WeChatにバインドする",
		"share_rewards": "報酬の共有：",
		"commission_ins": "コミッションの決済日は毎日の決済で、友達や友達の輪と共有すると共有報酬がもらえます！",
	},

	"vip_text": {
		"title": "私のVIP",
		"backToMe": "私に戻る",
		"me": "私",
		"my_level": "私のレベル：",
		"current_code": "現在のコーディング量：",
		"was_filed": "プロモーションジャックポット",
		"was_filed_info": "進むとボーナスがもらえます",
		"weeks_amounts": "周リジン",
		"weeks_amounts_info": "毎週月曜日の無料配布",
		"month_amounts": "毎月の贈り物",
		"month_amounts_info": "毎月1日に定刻に配布",
		"wash_code": "ウォッシュコード",
		"wash_code_info": "最大洗浄コード比",
		"but_text": "今行く",
		"get_error": "ゴールドコインを取得できませんでした。ゴールドコインをもう一度更新してください。",
		"amount_code": "コード量",
	},

	"xima_text": {
		"game_type": "ゲームの種類",
		"dm_total": "実効ベット額",
		"proportion": "最大洗浄コード比",
		"xm_amount": "ウォッシュコード量",
		"can_led_take": " 利用可能",
		"xm_total": "総洗浄量",
	},

	"PlayerCenter": {
		"jbxx": "基本情報",
		"zhmx": "アカウント詳細",
		"zdlb": "賭けのリスト",
		"my_vip": "私のVIP",
		"save": "保存する",
		"edit": "編集",
		"note": "備考",
		"betting_record": "賭け記録",
		"trading_hours": "取引時間",
		"trading_type": "トランザクションタイプ",
		"change_amount": "金額の変更",
		"balance": "残高",
		"today": "今日では",
		"yesterday": "昨日",
		"a_month": "月",
		"all": "すべて",
		"status": "取引状況",
		"chess": "チェス",
		"send_time": "支払い時間",
		"note_num": "ゲームベット番号",
		"betting_amount": "賭け金額",
		"has_been": "受賞",
		"gaming": "ゲームプラットフォーム",

		"currencyType": "通貨を変換する",
		"rate": "為替レート",
	},

	"RechargeLayer": {
		"note": "備考",
		"often_play": "プレイヤーがよくプレイするクイック量",
		"between": "1から100までの金額を入力してください",
		"gift100": "100％無料",
		"payment_account": "アカウントの受信",
		"payee": "受取人",
		"where": "アカウントバンク",
		"depositors": "寄託者の本名を記入してください",
		"note_info": "備考情報",
		"step": "最初のステップ：支払いのQRコードをスキャンして再充電します",
		"step2": "ステップ2：リチャージ情報を入力してリチャージを送信する",
		"session": "最近の会話",
		"official": "公式認証",
		"gift2": "2％無料",
		"channel": "*トップアップチャネルを選択してください\ n *チャネルを選択する前に、為替レートを注意深く確認してください",
		"qr_code": "保存\ n保存\ n2つの\ nディメンション\ nコード",
		"digital_currency": "デジタル通貨リチャージチャネル1",
		"step_1": "ステップ1：USDTの金額を選択する",
		"formula": "口座金額への最終リチャージの計算式：70.86 = 10.1234USDT *現在の為替レート7元",
		"step3": "ステップ3：引き出し情報を提供する",
		"actual_account": "受け取ったUSDTの実際の金額",
		"poundage": "手数料0-50USDT",
		"instr": "※左の写真のように厳密にご記入ください！ \ n *間違って入力すると、時間どおりに到着できなくなります。",
		"not_account": "リチャージはまだ届いていませんか？",
		"rate": "為替レート：1USDT = 99元",
		"prompt_info": "プロンプト情報",
		"czjl": "充電記録",
		"czjc": "充電チュートリアル",
		"ljcz": "今すぐ充電",
		"czje": "充電量",
		"zfpz": "支払いバウチャー",
		"save_code": "QRコードを保存する",
		"xuanchuan": "公式エージェントのリチャージ\ n絶対的な評判保証",
		"usdt_address": "USDTデポジットアドレス：",
		"syb": "前",
		"complete": "実施する",
		"usdt_num": "USDT金額のリチャージ：",
		"go_recharge": "トップアップに移動",
		"back": "戻る",
		"creat_order": "注文を作成する",
		"real_usdt": "受け取ったUSDTの実際の金額",
		"sxf": "手数料",
		"date": "時間",
		"state": "状態",
		"jine": "量",
		"detail": "詳細",
		"rechargeCourse": "充電チュートリアル",
		"rate2coin": "為替レート：1ゴールドコイン=",
		"currency_symbol": "¥",
		"currency_word": "RMB",
		"get_coins": "受け取ったゴールドコイン：",
		"get_money": "いただいた分量：",
		"go_pay": "コピーは成功しました。すぐに支払いますか？",
		"pay_now": "すぐに支払う",
		"pay_not_support": "一時的にお支払いいただけません！",
	},

	"SettingLayer": {
		"bind_equi": "デバイスバインディング",
		"basic_info": "基本情報",
		"account": "口座番号：",
		"level": "レベル：",
		"set_sound": "サウンド設定",
		"music": "音楽",
		"sound": "サウンドエフェクト",
		"switch_music": "音楽の切り替え",
		"song2": "私が死ぬとき私は愛さなければなりません",
		"song1": "曲1",
		"inp_landing_paw": "パスワードを入力してください",
		"inp_old_paw": "古いパスワードを入力してください",
		"old_paw": "以前のパスワード：",
		"inp_new_paw": "新しいパスワードを入力してください",
		"new_paw": "新しいパスワード：",
		"con_new_paw": "新しいパスワードを確認します",
		"con_paw": "パスワードを認証する：",
		"check_update": "アップデートを確認する",
		"determine": "決定する",
		"bind_shuom1": "*デバイスをバインドした後、クイックログインを使用してバインドされたデバイスに直接ログインできます。",
		"bind_shuom2": "*アカウントを登録するためにすばやくログインすると、現在のデバイスが自動的にバインドされます。",
		"bind_shuom3": "*デバイスをバインドした後、IDを確認してバインドを解除できます。",
		"bind_shuom4": "※本人確認には、アカウントのログインパスワードを入力する必要があります。",
		"bind_shuom5": "※ご使用にはご注意ください！",
		"bind_shuom6": "現在のデバイスはバインドされています",
		"bind_shuom7": "すでにバインドされている他のデバイス",
		"landing_paw": "ログインパスワード：",
		"test": "テスト環境",
		"huidu": "グレースケール環境",
		"standbyTest": "代替テスト環境",
		"mute_all": "すべてミュート",
		"change_account": "アカウントを切り替える",
		"confirm_change": "変更を確認する",
		"confirm_bind": "デバイスバインディング",
		"unbind_device": "デバイスのバインドを解除します",
		"unbind": "解放する",
	},

	"Task": {
		"share_task": "タスクを共有する",
		"MG_electronic": "MGエレクトロニクス",
		"cash": "現金",
		"complete": "終わる",
		"application": "申請中",
		"refused": "拒否されました",
		"disclose_data": "情報を送信する",
		"submit": "参加する",
		"Audit_failure": "監査の失敗",
		"friends_account": "スクリーンショットを送信",
		"apply_reward": "報酬を申請する",
		"pic_limit": "アップロードできるのはJPG、JPEG、PNGのみで、100万以下です。",
		"btn_choose": "選択する",
		"update_pic": "画像のアップロード：",
		"editTips": "アップロードした写真を選択してください",
		"task_details": "タスクの詳細",
		"Task_details": "タスクの詳細：",
		"task_name": "ミッション名：",
		"task_state": "タスクの説明：",
		"share": "共有する",
		"task_progress": "タスクの進行状況：",
		"know": "知っている",
		"q_update_pic": "最初に写真をアップロードしてください",
		"activit_Shut": "タスクアクティビティは終了しました",
		"Qbind_wx": "最初にWeChatをバインドしてください",
		"Application_success": "申し込みは成功しました。審査をお待ちください",
		"Succ_application_Award": "報酬の申請の成功",
		"task_ShutDown": "共有タスクは終了しました",
	},

	"ThirdGamesListLayer": {
		"xsj": "ニューワールドチェス",
		"tall_game": "合計1ゲーム",
		"inp_game": "ゲーム名を入力してください",
	},

	"TuiGuangLayer": {
		"title": "推進機関",
		"my_agent": "私のエージェント",
		"agent_recruit": "エージェント募集",
		"agent_introduced": "エージェント紹介",
		"players_query": "プレイヤークエリ",
		"results_query": "パフォーマンスクエリ",
		"rich_list": "ウェルスリスト",
		"my_id": "私のID：",
		"under": "昨日の直接手数料：",
		"offline": "昨日のオフライン委員会：",
		"under_player": "直接プレイヤー：",
		"day_new": "昨日追加：",
		"offline_player": "オフラインプレーヤー：",
		"share_rewards": "報酬の共有：",
		"commission_ins": "コミッションの決済日は毎日の決済で、友達や友達の輪と共有すると共有報酬がもらえます！",
		"save_qr_code": "QRコードを保存する",
		"copy": "コピー",
		"bind_wx": "WeChatにバインドする",
		"Imm_receive": "今すぐ入手",
		"share_detail": "詳細を共有する",
		"get_record": "収集記録",
		"historyCom": "過去の総手数料",
		"canReceive": "受取手数料",
		"zhishu_renshu": "直属の部下の数：",
		"tall_bets_today": "今日の総効果的な賭け：",
		"inp_id": "IDを入力してください",
		"query": "お問い合わせ",
		"reset": "リセット",
		"bets_today": "今日の有効な賭け",
		"total_bets": "有効な賭けの合計",
		"directly_num": "直属の部下の数",
		"operation": "オペレーティング",
		"details": "詳細>>",
		"date": "日付",
		"under_new": "直接追加",
		"team_new": "新しいチーム",
		"directly_under": "直接コミッションリベート",
		"total_amount": "トータルリベート",
		"reward": "褒賞",
		"contact": "講師に連絡する",
		"ranking": "ランク",
		"player_info": "プレイヤー情報",
		"rebate_month": "今月の委員会のリベート",
		"rewards_month": "今月の報酬を共有する",
		"detailed_info": "詳細",
		"zhuce_shijian": "登録時間：",
		"jtyxtz": "今日の有効な賭け：",
		"tdrsxz": "チーム数（新規）：",
		"jrtdyxtz": "今日のチームの有効な賭け：",
		"directly_num_new": "直属の部下数（新規）：",
		"zuoriyongjing": "昨日の手数料：",
		"commission_payable": "引き出し可能な手数料：",
		"lishizongyong": "過去の総手数料：",
		"zyxtz": "有効な賭けの合計：",
		"agent_commission": "代理店委員会",
		"share_commission": "シェアコミッション",
		"team_num": "チームサイズ",
		"not_directly_under": "非直接リベート",
		"account": "口座番号",
		"between": "関係",
		"effective_betting": "有効なベット/リベート額",
		"ratio": "リベート率",
		"total": "合計",
		"share": "共有する",
	},

	"WithdrawLayer": {
		"self_help": "セルフサービスの撤退",
		"withdrawal_record": "引き出し記録",
		"wallet_management": "ウォレット管理",
		"inp_withdrawal_amount": "引き出し金額を入力してください",
		"warm_prompt": "チップ",
		"current_need_adjust_amount": "現金を引き出すには、まだ<color =＃00ff00> 0 </ c>フローが必要です",
		"current_need": "まだ必要",
		"can_carry": "引き出す前に水を流す",
		"adjust_amount": "ドットをドラッグして引き出し額を調整します",
		"bank": "ICBC",
		"change_bank_card": "銀行カードを変更する",
		"not_bind_card": "まだ銀行カードをバインドしていません。バインドに移動してください",
		"not_tixian_paw": "引き出しパスワードを設定していません。最初に引き出しパスワードを設定してください",
		"tixian_paw": "パスワードを撤回する",
		"set6num_paw": "6桁のパスワードを設定してください",
		"confirm_password": "パスワードを認証する",
		"again_confirm_password": "確認のため、パスワードをもう一度入力してください",
		"inp_tixian_paw": "引き出しパスワードを入力してください",
		"topUp_failure": "再充電に失敗しました",
		"bank_paragraph": "銀行の撤退",
		"add_card": "銀行カードを追加する",
		"cardholder_name": "カード所有者の名前を入力してください",
		"cardholder": "カード所有者：",
		"card_code": "銀行カード口座番号：",
		"inp_bank_card_code": "銀行カード番号を入力してください",
		"inp_bank_address": "銀行の住所を入力してください",
		"bank_address": "口座開設住所：",
		"bank_address_msg": "ヒント：アカウントバンクを正しく選択し、本名をバインドしてください。アカウントは決済時に直接アカウントに転送されます。資金の安全のため、バインド後に自由に変更することはできません。変更が必要な場合は、カスタマーサービスにお問い合わせください。",
		"choose_bank": "銀行を選択：",
		"inp_aliPay_name": "Alipayの本名を入力してください",
		"inp_aliPay_code": "Alipayアカウントを入力してください",
		"name": "名前：",
		"aliPay_account": "Alipayアカウント：",
		"aliPay_account_msg": "ヒント：Alipayを正しく選択すると、決済時に変更されたアカウントに直接転送されます。資金の安全のため、バインド後に自由に変更することはできません。変更が必要な場合は、カスタマーサービスにお問い合わせください。",
		"inp_tixian_dizhi": "引き出し先住所を入力してください",
		"rate": "為替レート",
		"daozhangUSDT": "受け取ったUSDTの金額",
		"confirm_tixian": "撤退を確認する",
		"max": "最大",
		"confirm_submit": "提出の確認",
		"tixian_time": "撤退時間",
		"jine": "量",
		"state": "状態",
		"order_info": "注文情報",
		"confirm_bind": "バインディングを決定する",
		"confirm_select": "選択を確認する",
		"select_bank_card": "銀行カードを選択",
		"bizhong_xuanze": "通貨の選択：",
		"tixian_dizhi": "引き出し先住所：",
		"more_than_0": "引き出し額は0より大きくする必要があります",
	},

	"XimaLayer": {
		"title": "ウォッシュコード",
		"selfHelp_washing": "自己洗浄コード",
		"xima_record": "コードレコードを洗浄する",
		"xima_proportion": "ウォッシュコード比",
		"fishing_game": "釣りゲーム",
		"to_complete": "終わる",
		"receive": "受け取る",
		"chess": "チェス",
		"fishing": "釣り",
		"electronic": "電子",
		"reality": "実在の人物",
		"sports": "体育",
		"eSports": "ゲーム",
		"lottery": "宝くじ",
		"game": "ゲーム",
		"key_get": "ワンクリックコレクション",
		"get_time": "収集時間",
		"damaliang": "実効ベット額",
		"xima_amount": "ウォッシュコード量",
		"details": "詳細",
		"viewI": "表示>>",
		"xima_details": "コード洗浄の詳細",
		"heitao_chess": "スペード",
		"chess_game": "ボードゲーム",
		"sports_events": "スポーツイベント",
		"electronic_game": "電子ゲーム",
		"lottery_betting": "宝くじ賭け",
		"real_video": "ライブビデオ",
		"eSports_game": "Eスポーツゲーム",
		"game_name": "ゲーム名",
		"click_details": "詳細はこちら",
		"tianmei_chess": "天美チェス",
		"detailsI": "詳細>>",
		"xima_range": "コード洗浄範囲",
		"vip_level": "VIPレベル",
		"tournament": "Eスポーツ",
		"lottery_game": "宝くじゲーム",
	},

	"Signal": {
		"switch": "スイッチライン",
		"speed": "加速線",
		"choose": "行を選択",
		"reconnect": "再接続",
		"helpful_hints": "フレンドリーなリマインダー：遅延が少ないほど、ネットワークは良好になります",
		"is_msg": "これはメッセージです",
		"in_test": "チェック",
		"general": "一般",
		"smooth": "スムーズ",
		"speed1": "速度",
		"current_use": "現在使用中",
	},

	"general": {
		"name": "名前",
		"activity": "包括的な活動",
		"xzsm": "発行者のアドレス、いつでも最新のインストールアドレスを取得してください。",
		"wszl": "完全な資料",
		"qdcj": "サインインボーナス",
		"xtyj": "システムメール",
		"xxzx": "メッセージセンター",
		"bt": "題名",
		"sj": "時間",
		"nr": "コンテンツ",
		"xx": "ニュース",
		"dlq": "保留中",
		"ylq": "受け取りました",
		"ygq": "期限切れ",
		"ready_all": "すべて読んだ",
		"del_all": "すべて削除",
		"get_all": "すべてを請求する",
	},

	"EllipticalStage": {
		"musicNmae": "勝利のために",
	},

	"CheckHot": {
		"update_msg": "新しいバージョンの更新が検出され、ダウンロードが完了しました。クリックして更新を完了してください。",
		"update": "更新",
		"lack_resources": "アートリソースの不足",
		"kaiyuan_chess": "カイユアンチェス",
		"leyou_chess": "ルトゥールチェス",
		"xinshijie_chess": "ニューワールドチェス",
		"ag_electronic": "AGエレクトロニクス",
		"pg_electronic": "PGエレクトロニクス",
		"mg_electronic": "MGエレクトロニクス",
	},

	"HallUI": {
		"copy_succ": "正常にコピー",
		"moment_open": "まだ開いていません",
		"no_announcement": "発表内容なし",
		"tmpled_err": "テンプレート設定エラー、カスタマーサービスにお問い合わせください",
		"game_maintain": "ゲームはメンテナンス中です",
		"game_loading": "ゲームが読み込まれています",
		"get_err": "ゴールドコインを取得できませんでした。ゴールドコインをもう一度更新してください。",
		"login": "ログインする",
		"register": "登録済み",
		"copy_id": "IDをコピー",
		"huodong": "アクティビティ",
		"task": "仕事",
		"setting": "セットアップ",
		"remen": "人気",
		"qipai": "チェス",
		"buyu": "釣り",
		"zhenren": "実在の人物",
		"dianzi": "電子",
		"tiyu": "体育",
		"caipiao": "宝くじ",
		"dianjing": "ゲーム",
		"tuiguangdaili": "推進機関",
		"xima": "ウォッシュコード",
		"xiaoxi": "ニュース",
		"kefu": "顧客サービス",
		"xiufugongju": "修復ツール",
		"gengduo": "もっと",
		"qiandao": "サインイン",
		"paihangbang": "リーダーボード",
		"gonggao": "発表",
		"tixian": "撤退",
		"chongzhi": "充電する",
		"xianshilingqu": "期間限定コレクション",
		"remenyouxi": "トップゲーム",
		"zuijingchangwan": "最近再生しました",
		"play_now": "賭け",
	},

	"BasicsJS": {
		"tall": "合計で",
		"minGame": "小さなゲーム",
		"play_game": "最近プレイしたゲームはありません",
		"editor_succ": "正常に編集",
		"yi_bind": "バウンド",
		"wu_bind": "アンバウンド",
		"inp_amount": "充電量を入力してください",
		"inp_correct_amount": "正しい充電量を入力してください",
		"no_login_yinshang": "未登録の銀行商人",
		"gift": "贈り物",
		"voucher_cannot_empty": "支払いバウチャーを空にすることはできません",
		"pic_loading": "写真を読み込んでいます",
		"amount_between": "間の量",
		"card": "カード",
		"note_info": "備考情報を入力して、アカウントにすばやくアクセスしてください",
		"credit_cord": "カード番号の受け取り",
		"rate": "為替レート",
		"not_channel": "充電チャネルが存在しません。カスタマーサービスにお問い合わせください",
		"select_amount": "充電量を選択してください",
		"confirm_cancellation_order": "注文をキャンセルしてもよろしいですか",
		"been_submit": "注文が送信されました。しばらくお待ちください",
		"Eventually_topUp_amount": "アカウント金額への最終的なリチャージは",
		"current_rate": "現在の為替レート",
		"Outstanding_orders": "続行するかどうか、未完了の注文があります",
		"Continue": "続ける",
		"Cancel_order": "注文をキャンセルする",
		"bind_succ": "正常にバインド",
		"inp_paw": "最初にパスワードを入力してください",
		"remove_bind_succ": "正常にバインド解除",
		"first": "最初",
		"day": "日",
		"Sports_eSports": "スポーツEスポーツ",
		"directly": "直下",
		"not_directly": "直下ではない",
		"amount_not_null": "引き出し金額を空にすることはできませんので、ご記入ください",
		"WithdrawalAmount": "引き出し額",
		"Qbind": "最初にバインドしてください",
		"moment_not_bind": "あなたは現在拘束されていません",
		"QgoBind": "バインドに行ってください",
		"replace": "交換",
		"between": "の間に",
		"request_submit": "引き出しリクエストが送信されました",
		"ContinueToCarry": "撤退を続ける",
		"GiveUpWithdrawal": "撤退をやめる",
		"Qxuanding": "ヒント：正しく選択してください",
		"jiesuanshihou": "これに直接転送されます",
		"zhuanghaowanquan": "口座番号は、資金の安全のため、拘束後は自由に変更することはできません。変更が必要な場合は、カスタマーサービスまでご連絡ください。",
		"phoneNo": "電話番号",
		"add": "追加",
		"updateTimeout": "更新のタイムアウトを確認し、ネットワークが正常であることを確認してください",
		"retry": "リトライ",
		"err_retry": "ファイルのダウンロード中にエラーが発生しました。再試行してください",
		"err_check_network": "ネットワークは廃業しています。ネットワークが正常かどうかを確認してください",
		"no_get_data": "リソースの更新はありません。しばらくしてからもう一度お試しください",
		"network_retry": "ネットワークが切断されています。ネットワーク接続が正常かどうかを確認してください",
		"Quit_game": "ゲームを終了する",
		"ReturnHall": "ロビーに戻る",
		"daozhangUSDT": "受け取ったUSDTの金額",
	},
};